import { API_ENDPOINTS } from '../../../constants/apiEndpoints';
import { ENVIRONMENT_CONFIG } from '../../../constants/environmentConfig';
import fetcher from '../../../helpers/fetcher';

type UpdatePriceStatus = {
  status?: string;
  rejectRemark?: string;
  updateTime?: number;
};

export const getAllCitizenReportedPriceDetails = async (filterParams: any) => {
  try {
    const response = await fetcher.get(
      API_ENDPOINTS.CITIZEN_INSPECTION.GET_CITIZEN_INSPECTION_DETAIL,
      filterParams,
      {},
      ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const getAllCitizenInspectionDetailsById = async (inspectionId: any) => {
  try {
    const response = await fetcher.get(
      `${API_ENDPOINTS.CITIZEN_INSPECTION.GET_CITIZEN_INSPECTION}/${inspectionId}`,
      {},
      {},
      ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const downloadAllCitizenInspectionDetails = async (filterParams: any) => {
  try {
    const response = await fetcher.get(
      API_ENDPOINTS.CITIZEN_INSPECTION.DOWNLOAD_CITIZEN_INSPECTION_DETAIL,
      filterParams,
      {},
      ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
    );
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const updateCitizenPriceStatus = (
  id: string | undefined,
  priceData: UpdatePriceStatus
): Promise<any> => {
  return fetcher.patch(
    `${API_ENDPOINTS.CITIZEN_PRICE.CITIZEN_PRICE_STATUS_UPDATE}/${id}`,
    priceData,
    {},
    ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE
  );
};

export const updateCitizenPriceStatusBulk = (
  priceData: any
): Promise<any> => {
  return fetcher.patch(
    `${API_ENDPOINTS.CITIZEN_PRICE.CITIZEN_PRICE_STATUS_UPDATE_BULK}`,
    priceData,
    {},
    ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE
  );
};
